<template>
  <div class="container">
    <div class="seach-container">
      <div class="form-container">
        <div class="form-box-item">
          <div class="form-box-item-label">
            <span class="letterspance2">关键字</span>
          </div>
          <div class="form-box-item-item">
            <el-input
              v-model="query.keyword"
              size="small"
              placeholder="请输入关键字"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="form-container">
        <div class="form-box-item">
          <div class="form-box-item-label">
            <span class="letterspance2">状态</span>
          </div>
          <div class="form-box-item-item">
            <el-select v-model="query.state" size="small" placeholder="请选择">
              <el-option label="待处理" value="5" v-if="roleflag"></el-option>
              <el-option label="进行中" value="1"></el-option>
              <el-option label="已拒绝" value="2"></el-option>
              <el-option label="已通过" value="3"></el-option>
              <el-option label="全部" value="4"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="form-container">
        <div class="form-box-item serch-operate" >
          <el-button type="primary" size="mini" icon="el-icon-search" @click="getModifyFlowList">搜索</el-button>
        </div>
      </div>
      <div class="form-container" style="float: right;">
        <div class="form-box-item serch-operate" >
          <el-button type="primary" size="mini" @click="chooseFlowDialog" v-if="hasAddBtn">新增补录</el-button>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      :max-height="scrollHeight"
    >
      <el-table-column
        v-for="col in tableCols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        :align="col.align">
        <template #default="scope">
          <div v-if="(scope.column.property==='Operation')">
            <el-button size="mini" @click="auditModifyBtnClick(scope.row.ID, 'view')" v-if="scope.row.btns.indexOf('view')>-1">查看</el-button>
            <el-button size="mini" type="primary" @click="chooseFlow2(scope.row.ID)" v-if="scope.row.btns.indexOf('dbAudit')>-1">修改</el-button>
            <el-button size="mini" type="primary" @click="auditModifyBtnClick(scope.row.ID,'fkAudit')" v-if="scope.row.btns.indexOf('fxAudit')>-1">风控审核</el-button>
            <el-button size="mini" type="primary" @click="auditModifyBtnClick(scope.row.ID,'fzAudit')" v-if="scope.row.btns.indexOf('fzAudit')>-1">分管风控领导审核</el-button>
          </div>
          <div v-else-if="(scope.column.property==='Status')">
            <span v-if="(scope.row.Status==1)">进行中</span>
            <span style="color: red" v-if="(scope.row.Status==2)">已拒绝</span>
            <span style="color: green" v-if="(scope.row.Status==3)">已通过</span>
          </div>
          <div v-else-if="(scope.column.property==='Company')">
            <span v-if="scope.row.Company">{{scope.row.Company}}</span>
            <span v-else>{{scope.row.Name}}</span>
          </div>
          <div v-else-if="(scope.column.property==='CurrentNode')">
            <span v-if="(scope.row.CurrentNode==1)">担保经理审核</span>
            <span v-if="(scope.row.CurrentNode==2 && scope.row.Status == 1)">等待风控审核</span>
            <span v-if="(scope.row.CurrentNode==2 && scope.row.Status == 2)">风控拒绝</span>
            <span v-if="(scope.row.CurrentNode==3 && scope.row.Status == 1)">等待分管风控领导审核</span>
            <span v-if="(scope.row.CurrentNode==3 && scope.row.Status == 2)">分管风控领导拒绝</span>
            <span v-if="(scope.row.CurrentNode==4)">已通过完成</span>
          </div>
          <div v-else>
            {{scope.row[scope.column.property]}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="query.pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
    <!--选择流程的对话框--->
    <el-dialog title="选择流程" v-model="flowDialogShow" width="60%" top="7vh">
      <el-form ref="detailForm" label-width="110px" :inline="true">
        <el-form-item label="关键字：">
          <el-input
            v-model="flowQuery.keywords"
            size="small"
            style="width: 220px;"
            placeholder="请输入申请人"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button  size="small" type="primary"  @click="getFlowList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="flowList"
        border
        :max-height="600">
        <el-table-column
          v-for="col in flowCols"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :align="col.align">
          <template #default="scope">
            <div v-if="(scope.column.property==='Operation')">
              <el-button
                size="mini"
                type="primary"
                @click="chooseFlow(scope.row.Id,scope.row.ApplyID)">数据补录</el-button>
            </div>
            <div v-else>
              {{scope.row[scope.column.property]}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          @size-change="handleFlowSizeChange"
          @current-change="handleFlowPageChange"
          :current-page="flowQuery.pageIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="flowQuery.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="flowPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
    <modifyFlowAdd v-if="showModifyFlowInfo" :addType="addType" :flowId="chooseFlowId" :closeCallback="modifyFlowInfoClose" :submitCallback="modifyFlowInfoSubmit"></modifyFlowAdd>
    <modifyFlowAudit v-if="showAuditModifyFlowInfo" :showType="auditModifyFlowType" :modifyFlowId="chooseModifyFlowId" :closeCallback="auditModifyFlowInfoClose" :submitCallback="auditModifyFlowInfoSubmit"></modifyFlowAudit>
  </div>
</template>

<script>
  import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
</style>